import { TextField } from '@mui/material';
import { forwardRef } from 'react';

const phoneInput = (props, ref) => {
  return <TextField {...props} inputRef={ref} fullWidth />;
};
export default forwardRef(phoneInput);
